export type HeaderMenuMode = 'old' | 'new';

const HEADER_MENU_MODE_KEY = 'useOldMenu';

type HeaderMenuModeStorage = Pick<Storage, 'getItem' | 'setItem'>;

export function parseHeaderMenuMode(value: string | null): HeaderMenuMode {
  if (value === 'old' || value === 'true') {
    return 'old';
  }

  return 'new';
}

export function isOldHeaderMenuMode(mode: HeaderMenuMode): boolean {
  return mode === 'old';
}

export function readHeaderMenuMode(
  storage: Pick<Storage, 'getItem'> = localStorage
): HeaderMenuMode {
  return parseHeaderMenuMode(storage.getItem(HEADER_MENU_MODE_KEY));
}

export function clearHeaderMenuMode(storage: Pick<Storage, 'removeItem'> = localStorage): void {
  storage.removeItem(HEADER_MENU_MODE_KEY);
}

export function writeHeaderMenuMode(
  mode: HeaderMenuMode,
  storage: HeaderMenuModeStorage = localStorage
): void {
  storage.setItem(HEADER_MENU_MODE_KEY, mode);
}
